document.addEventListener('DOMContentLoaded', () => {

    if (window.location.href === 'https://tuareq.com/products/gift-card') {
      const variantButtons = document.querySelectorAll('.variant-picker__option-values input');

      const formatCurrency = (amount, fractionDigits) => {
          return new Intl.NumberFormat('es-AR', {
              style: 'currency',
              currency: 'ARS',
              minimumFractionDigits: fractionDigits,
              maximumFractionDigits: fractionDigits
          }).format(amount).replace(/\s/g, '');
      };

      const updatePrices = (selectedValue) => {
          const numericValue = parseInt(selectedValue.replace(/\./g, ''), 10);
          const transferenciaValue = numericValue * 0.7;
          const installmentSixValue = numericValue / 9;
          const installmentTwelveValue = numericValue / 12;

          const formattedTransferenciaValue = formatCurrency(transferenciaValue, 2);
          const formattedInstallmentSixValue = formatCurrency(installmentSixValue, 0);
          const formattedInstallmentTwelveValue = formatCurrency(installmentTwelveValue, 0);

          document.getElementById('transfer-price').textContent = formattedTransferenciaValue;
          document.getElementById('installment-price-6').textContent = formattedInstallmentSixValue;
          document.getElementById('installment-price-12').textContent = formattedInstallmentTwelveValue;
      };

      variantButtons.forEach(button => {
          button.addEventListener('change', function() {
              updatePrices(this.value);
          });
      });
    }
});

/* =====================================================================================================================
 * VANTRA — DOS CAMINOS DE COMPRA DIRECTOS DESDE LA FICHA   ·   17/09/2026  (v8)
 * =====================================================================================================================
 *
 * CÓMO FUNCIONA — EL HALLAZGO QUE SIMPLIFICÓ TODO
 * La app Scala Descontos no se maneja por botón: se maneja por un ATRIBUTO DE CARRITO llamado
 * _scaladiscount. Con "1" aplica el descuento, con "0" no lo aplica. Verificado en vivo el 17/09/2026:
 *
 *   _scaladiscount = "1"  →  carrito $258.800 → $232.920   →  checkout con "Descuento en pedidos" −$25.880
 *   _scaladiscount = "0"  →  carrito $258.800              →  checkout sin descuento
 *
 * Por eso NO hace falta pasar por /cart, ni buscar el botón de Scala en el shadow DOM, ni mostrar un
 * overlay de transición. Todo eso era un rodeo innecesario de las versiones anteriores y se eliminó.
 *
 * FLUJO ACTUAL — un clic, sin pantallas intermedias
 *   VERDE (transferencia) → agrega al carrito → _scaladiscount=1 → /checkout con 10% OFF
 *   NEGRO (tarjeta)       → agrega al carrito → _scaladiscount=0 → /checkout a precio de lista
 *
 * Además se graba el atributo "Medio de pago elegido" (Transferencia / USDT ó Tarjeta), que viaja al
 * pedido y se ve en el admin. Sirve para conciliar transferencias y como condición para una app de
 * reglas de pago si más adelante se quiere ocultar medios de pago según el camino elegido.
 *
 * GARANTÍA DE PRECIO
 * Si la escritura del atributo falla, NO se manda al cliente al checkout: se muestra el error en la
 * ficha. Nunca puede pasar que el botón prometa $232.920 y el checkout cobre $258.800, ni al revés.
 * La respuesta de /cart/update.js se verifica: si _scaladiscount no quedó en el valor esperado, se corta.
 *
 * OTRAS NOTAS (verificadas en vivo)
 * · /cart/add.js devuelve 422 "Tu carrito ya tiene la cantidad máxima de este artículo" cuando el
 *   producto ya estaba en el carrito. Eso NO es error: si está en el carrito, se sigue.
 * · Shopify serializa las mutaciones de carrito por sesión: dos pedidos simultáneos pueden pisarse.
 *   De ahí el reintento del alta.
 * · Ningún botón puede quedar muerto: todo fetch tiene timeout y un watchdog reactiva a los 12 segundos.
 *
 * POR QUÉ VIVE ACÁ: el tema carga custom.js en todas las páginas.
 * PARA REVERTIR: borrar este bloque hasta "FIN BLOQUE VANTRA" y la línea de render en buy-buttons.liquid.
 * ===================================================================================================================== */
(function () {
  'use strict';

  var FETCH_TIMEOUT_MS = 6000;
  var WATCHDOG_MS = 12000;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function track(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, props || {});
      }
    } catch (e) { /* la medición nunca puede romper la compra */ }
  }

  function fetchWithTimeout(url, opts, ms) {
    opts = opts || {};
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    if (ctrl) opts.signal = ctrl.signal;

    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || FETCH_TIMEOUT_MS);

    return fetch(url, opts).then(
      function (r) { clearTimeout(timer); return r; },
      function (e) { clearTimeout(timer); throw e; }
    );
  }

  /* true / false / null. null = no se pudo saber. */
  function cartHasVariant(variantId) {
    return fetchWithTimeout(root() + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(variantId)) return true;
        }
        return false;
      })
      .catch(function () { return null; });
  }

  function addToCart(id, qty) {
    return fetchWithTimeout(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    });
  }

  /* Fija el medio de pago y el descuento de Scala. Verifica que haya quedado: de eso depende el precio. */
  function fijarMedioDePago(modo) {
    var valorScala = (modo === 'transfer') ? '1' : '0';
    var etiqueta = (modo === 'transfer') ? 'Transferencia / USDT' : 'Tarjeta';

    var attrs = {};
    attrs['_scaladiscount'] = valorScala;
    attrs['Medio de pago elegido'] = etiqueta;

    return fetchWithTimeout(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('No pudimos preparar tu pago. Probá de nuevo.');
      return r.json();
    }).then(function (cart) {
      var quedo = (cart && cart.attributes) ? String(cart.attributes['_scaladiscount']) : null;
      if (quedo !== valorScala) {
        throw new Error('No pudimos preparar tu pago. Probá de nuevo.');
      }
      return cart;
    });
  }

  /* ------------------------------------------------------------------------------------------------------------------
   * FICHA DE PRODUCTO — los dos botones
   * ---------------------------------------------------------------------------------------------------------------- */
  if (!window.customElements.get('vantra-transfer-buy')) {
    window.customElements.define('vantra-transfer-buy', class extends HTMLElement {
      connectedCallback() {
        this.ctas = [].slice.call(this.querySelectorAll('[data-vantra-cta]'));
        if (!this.ctas.length) return;

        this.noteEl = this.querySelector('[data-vantra-note]');
        this.form = document.getElementById(this.dataset.formId) || this.closest('form');

        this.subs = {
          transfer: this.querySelector('[data-vantra-amount="transfer"]'),
          card: this.querySelector('[data-vantra-amount="card"]')
        };
        this.labels = {
          transfer: this.querySelector('[data-vantra-label="transfer"]'),
          card: this.querySelector('[data-vantra-label="card"]')
        };

        this.cuotasTexto = this.subs.card ? this.subs.card.textContent.trim() : '';

        try {
          var raw = this.querySelector('[data-vantra-prices]');
          this.prices = raw ? JSON.parse(raw.textContent) : {};
        } catch (e) {
          this.prices = {};
        }

        this.money = new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });

        this.paint();
        this.onChange = this.paint.bind(this);
        if (this.form) this.form.addEventListener('change', this.onChange);

        this._handlers = [];
        var self = this;
        this.ctas.forEach(function (btn) {
          var h = function () { self.handleClick(btn.getAttribute('data-vantra-cta'), btn); };
          btn.addEventListener('click', h);
          self._handlers.push({ btn: btn, h: h });
        });
      }

      disconnectedCallback() {
        if (this.form && this.onChange) this.form.removeEventListener('change', this.onChange);
        if (this._handlers) {
          this._handlers.forEach(function (x) { x.btn.removeEventListener('click', x.h); });
        }
        if (this._watchdog) clearTimeout(this._watchdog);
      }

      variantId() {
        if (this.form) {
          try {
            var fromData = new FormData(this.form).get('id');
            if (fromData) return String(fromData);
          } catch (e) {}

          var active = this.form.querySelector('[name="id"]:not([disabled])');
          if (active && active.value) return String(active.value);
        }

        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl) return String(fromUrl);

        var hidden = this.form ? this.form.querySelector('[name="id"]') : null;
        return hidden && hidden.value ? String(hidden.value) : null;
      }

      quantity() {
        var input = this.form ? this.form.querySelector('[name="quantity"]') : null;
        var q = input ? parseInt(input.value, 10) : 1;
        return (!q || q < 1) ? 1 : q;
      }

      paint() {
        var id = this.variantId();
        var p = id ? this.prices[id] : null;

        if (this.subs.transfer) {
          this.subs.transfer.textContent = (p && p.t)
            ? this.money.format(p.t / 100) + ' por transferencia o USDT'
            : 'Transferencia bancaria o USDT';
        }
        if (this.subs.card) {
          this.subs.card.textContent = (p && p.f)
            ? this.money.format(p.f / 100) + ' · ' + this.cuotasTexto
            : this.cuotasTexto;
        }
      }

      fail(msg, evento, id, modo) {
        if (this._watchdog) { clearTimeout(this._watchdog); this._watchdog = null; }
        track(evento || 'pdp_buy_error', { variant_id: id, modo: modo, message: String(msg || '') });
        this.setBusy(false);
        if (this.noteEl) {
          this.noteEl.textContent = msg || 'No pudimos continuar. Probá de nuevo o tocá "Añadir al carrito".';
          this.noteEl.hidden = false;
        }
      }

      handleClick(modo, btn) {
        var self = this;
        var id = this.variantId();
        var qty = this.quantity();

        track('pdp_buy_click', {
          modo: modo,
          variant_id: id,
          quantity: qty,
          discount_pct: (modo === 'transfer') ? Number(this.dataset.pct || 10) : 0,
          path: window.location.pathname
        });

        if (!id) {
          var picker = document.querySelector('variant-picker, .variant-picker');
          if (picker && picker.scrollIntoView) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.setBusy(true, btn);

        this._watchdog = setTimeout(function () {
          self.fail('Se demoró más de lo normal. Probá de nuevo o tocá "Añadir al carrito".',
                    'pdp_buy_timeout', id, modo);
        }, WATCHDOG_MS);

        function alCheckout(reason) {
          // El precio ya está fijado en el carrito. Recién acá mandamos al cliente a pagar.
          if (self._watchdog) { clearTimeout(self._watchdog); self._watchdog = null; }
          track('pdp_buy_ok', { modo: modo, variant_id: id, reason: reason });
          window.location.href = root() + 'checkout';
        }

        function rendirse(res) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.description || body.message || ('No pudimos agregarlo (' + res.status + ').'));
          });
        }

        // 1) Asegurar el producto en el carrito
        cartHasVariant(id).then(function (alreadyThere) {
          if (alreadyThere === true) return 'ya_en_carrito';

          return addToCart(id, qty).then(function (res) {
            if (res.ok) return 'agregado';

            return cartHasVariant(id).then(function (nowThere) {
              if (nowThere === true) return 'tope_pero_en_carrito';

              // Reintento: Shopify serializa las mutaciones y un pedido simultáneo pudo pisarlo.
              return addToCart(id, qty).then(function (res2) {
                if (res2.ok) return 'agregado_reintento';

                return cartHasVariant(id).then(function (finalCheck) {
                  if (finalCheck === true) return 'reintento_en_carrito';
                  return rendirse(res2);
                });
              });
            });
          });
        // 2) Fijar el precio según el camino elegido, y sólo entonces ir a pagar
        }).then(function (reason) {
          return fijarMedioDePago(modo).then(function () { alCheckout(reason); });
        }).catch(function (e) {
          var aborted = e && (e.name === 'AbortError');
          self.fail(
            aborted ? 'La conexión tardó demasiado. Probá de nuevo.' : ((e && e.message) || ''),
            aborted ? 'pdp_buy_timeout' : 'pdp_buy_error',
            id, modo
          );
        });
      }

      setBusy(busy, btnActivo) {
        this.ctas.forEach(function (b) {
          b.disabled = busy;
          b.setAttribute('aria-busy', (busy && b === btnActivo) ? 'true' : 'false');
        });

        var modo = btnActivo ? btnActivo.getAttribute('data-vantra-cta') : null;
        var label = modo ? this.labels[modo] : null;

        if (busy && label) {
          if (!this._labelPrevio) this._labelPrevio = { modo: modo, texto: label.textContent };
          label.textContent = 'Preparando tu compra…';
        } else if (!busy && this._labelPrevio) {
          var prev = this.labels[this._labelPrevio.modo];
          if (prev) prev.textContent = this._labelPrevio.texto;
          this._labelPrevio = null;
        }

        if (this.noteEl && busy) this.noteEl.hidden = true;
      }
    });
  }
})();
/* ===================================== FIN BLOQUE VANTRA ============================================================ */
